import { createBrowserRouter } from 'react-router'
import { AppLayout } from './components/layout/AppLayout'
import { LauncherLayout } from './components/layout/LauncherLayout'
import { LauncherView } from './views/launcher/LauncherView'
import { RedirectView } from './views/launcher/RedirectView'
import { DashboardView } from './views/dashboard/DashboardView'
import { ApplicationsView } from './views/applications/ApplicationsView'
import { ClientsView } from './views/clients/ClientsView'
import { TitlesView } from './views/titles/TitlesView'
import { UsersView } from './views/users/UsersView'
import { PendingUsersView } from './views/pending-users/PendingUsersView'
import { ChangePasswordView } from './views/auth/ChangePasswordView'
import { SettingsView } from './views/settings/SettingsView'

export const router = createBrowserRouter([
  {
    path: '/',
    children: [
      // Launcher routes — minimal header, no sidebar
      {
        element: <LauncherLayout />,
        children: [
          { index: true, element: <LauncherView />, handle: { title: 'Apps' } },
          { path: 'redirect', element: <RedirectView />, handle: { title: 'Redirecting…' } },
        ],
      },
      // Admin routes — full layout with sidebar
      {
        element: <AppLayout />,
        children: [
          { path: 'dashboard', element: <DashboardView />, handle: { title: 'Dashboard' } },
          { path: 'users', element: <UsersView />, handle: { title: 'Users' } },
          { path: 'pending-users', element: <PendingUsersView />, handle: { title: 'Pending Users' } },
          { path: 'applications', element: <ApplicationsView />, handle: { title: 'Applications' } },
          { path: 'clients', element: <ClientsView />, handle: { title: 'Clients' } },
          { path: 'titles', element: <TitlesView />, handle: { title: 'Titles' } },
          { path: 'settings', element: <SettingsView />, handle: { title: 'Settings' } },
          { path: 'change-password', element: <ChangePasswordView />, handle: { title: 'Change Password' } },
        ],
      },
    ],
  },
])
